import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { settingsActions } from 'features/settings'

import { Loader } from 'components'
import Form from './Form'

class MembersPage extends Component {
	componentDidMount() {
		this.props.getTeam()

		// Reset loading state
		this.props.setLoadingState(true)
	}

	onRemoveTeamMember = id => {
		this.props.removeTeamMember(id)
	}

	onUpdateTeamMember = member => {
		const { updateTeamMember } = this.props

		updateTeamMember({
			id: member.id,
			role: member.role,
		})
	}

	onRemoveInvite = id => {
		this.props.removeInvite(id)
	}

	onUpdateInvite = invite => {
		console.log('onUpdateInvite', invite)

		// const { updateTeamMember } = this.props

		// updateTeamMember({
		// 	id: invite.id,
		// 	role: invite.role,
		// })
	}

	onReinvite = invite => {
		const { reinvite } = this.props

		reinvite(invite.id)
	}

	render() {
		const {
			loading,
			team,
			invites,
			userProfile,
			createInvites,
			openInvites,
		} = this.props

		const a = [...invites, ...team]

		if (loading) return <Loader />

		return (
			<Form
				enableReinitialize="true"
				initialValues={{
					members: a,
				}}
				userId={userProfile.id}
				members={a}
				updateTeamMember={this.onUpdateTeamMember}
				removeTeamMember={this.onRemoveTeamMember}
				updateInvite={this.onUpdateInvite}
				createInvites={createInvites}
				removeInvite={this.onRemoveInvite}
				reinvite={this.onReinvite}
				openInvites={openInvites}
			/>
		)
	}
}

MembersPage.propTypes = {
	loading: PropTypes.bool.isRequired,
	openInvites: PropTypes.bool,
	setLoadingState: PropTypes.func.isRequired,
	userProfile: PropTypes.shape({}).isRequired,
	team: PropTypes.arrayOf(PropTypes.object).isRequired,
	getTeam: PropTypes.func.isRequired,
	updateTeamMember: PropTypes.func.isRequired,
	removeTeamMember: PropTypes.func.isRequired,

	invites: PropTypes.arrayOf(PropTypes.object).isRequired,
	createInvites: PropTypes.func.isRequired,
	removeInvite: PropTypes.func.isRequired,
	reinvite: PropTypes.func.isRequired,
}

MembersPage.defaultProps = {
	openInvites: false,
}

const mapStateToProps = state => ({
	loading: state.settings.loading,
	userProfile: state.auth,
	team: state.settings.team,
	invites: state.settings.invites,
})

const mapDispatchToProps = {
	setLoadingState: settingsActions.setLoadingState,
	getTeam: settingsActions.getTeamRequest,
	updateTeamMember: settingsActions.updateTeamMemberRequest,
	removeTeamMember: settingsActions.removeTeamMemberRequest,
	createInvites: settingsActions.createInvitesRequest,
	removeInvite: settingsActions.removeInviteRequest,
	reinvite: settingsActions.reinviteRequest,
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(MembersPage)
)
